import { Component } from 'react';
import ReactDOM from 'react-dom';
import './Modal.css';

export class Modal extends Component {
  componentDidMount() {
    document.body.classList.add('ModalOpen');
  }

  componentWillUnmount() {
    document.body.classList.remove('ModalOpen');
  }

  render() {
    return ReactDOM.createPortal(this.props.children, document.body);
  }
}
